import { Settings } from '@mui/icons-material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../core-components/theme/components/Button/Button';
import NotificationSettingsModal from './NotificationSettingsModal';

export const NotificationSetting = () => {
    const { t } = useTranslation();
    const [settingsOpen, setSettingsOpen] = useState(false);
    const handleSettingsOpen = () => {
        setSettingsOpen(true);
    };

    const handleSettingsClose = () => {
        setSettingsOpen(false);
    };

    return (
        <>
            <Button startIcon={<Settings />} onClick={handleSettingsOpen} variant="contained">
                {t('notifications.settings.button', 'Settings')}
            </Button>
            {settingsOpen && <NotificationSettingsModal open={settingsOpen} onClose={handleSettingsClose} />}
        </>
    );
};

export default NotificationSettingsModal;
